import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Apply from '../views/Apply.vue'
import HosList from "../views/HosList.vue"
import ApplyList from '../views/ApplyList'
import Pay from '../views/Pay.vue'
import HosService from '../views/HosService.vue';
import HosDistrict from '../views/HosDistrict.vue'
import Upload from '../views/Upload.vue'
import Info from '../views/Info.vue'
import CopyPurpose from '../views/CopyPurpose.vue'
import CustomCopy from '../views/CustomCopy.vue'
import MakeUp from '../views/MakeUp.vue'
import Pause from '../views/Pause.vue'
import WeekendPause from '../views/WeekendPause.vue'
import Guide from '../views/Guide.vue'
import GuideDetail from '../views/GuideDetail.vue'
import Hotline from '../views/HotLine.vue'
import Logistics from '../views/Logistics.vue'
import Questionnaire from '../views/Questionnaire.vue'
import AdvertisingApply from '../views/AdvertisingApply.vue'
import AdverApplyAfter from '../views/AdverApplyAfter.vue'
import MakeInvoice from '../views/MakeInvoice.vue'
import DeleteOrder from '../views/DeleteOrder.vue'
import { server } from '../providers/http-service'
Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};
// let parentHosId;
const routes = [{

    path: '/',
    redirect: '/home'
},
{
    path: '/home',
    name: 'home',
    component: Home
},
{
    path: '/deleteorder',
    name: 'deleteorder',
    component: DeleteOrder
},
{
    path: '/apply/:hosId/:typeId',
    name: 'apply',
    component: Apply
},
{
    path: '/service/:hosId/:parentHosId',
    name: 'service',
    component: HosService
},
{
    path: '/district/:hosId',
    name: 'district',
    component: HosDistrict
},
{
    path: '/hos-list',
    name: 'hos-list',
    component: HosList
},
{
    path: '/apply-list',
    name: 'applylist',
    component: ApplyList,
    
},
{
    path: '/pay/:payId/:preFlag',
    name: 'pay',
    component: Pay
},
{
    path: '/upload',
    name: 'upload',
    component: Upload
},
{
    path: '/info/:patientName/:idCardNo',
    name: 'info',
    component: Info
},
{
    path: '/purpose',
    name: 'purpose',
    component: CopyPurpose
},
{
    path: '/custom',
    name: 'custom',
    component: CustomCopy
},
{
    path: '/makeup/:requestId',
    name: 'makeup',
    component: MakeUp
},
{
    path: '/pause',
    name: 'pause',
    component: Pause
},
{
    path: '/weekendpause',
    name: 'weekendpause',
    component: WeekendPause
},
{
    path: '/guide',
    name: 'guide',
    component: Guide
},
{
    path: '/guidedetail/:id',
    name: 'guidedetail',
    component: GuideDetail
},
{
    path: '/logistics',
    name: 'logistics',
    component: Logistics
},
{
    path: '/hotline',
    name: 'hotline',
    component: Hotline
},
{
    path: '/questionnaire',
    name: 'questionnaire',
    component: Questionnaire
},
{
    path: '/advertisingapply',
    name: 'advertisingapply',
    component: AdvertisingApply
},
{
    path: '/adverapplyafter/:cmsOrderId',
    name: 'adverapplyafter',
    component: AdverApplyAfter
},
{
    path: '/makeinvoice',
    name: 'makeinvoice',
    component: MakeInvoice
}

]

const router = new VueRouter({
    // mode: 'history',
    routes,

})
router.beforeEach((to, from, next) => {
    // 定期清理本地缓存
    let currentTime = new Date().getTime();
    let oldTime = Number(localStorage.getItem("localTime"));
    if (oldTime > 0) {
        let time = 1000 * 60 * 60 * 24 * 7
        if (currentTime - oldTime > time) {
            localStorage.clear();
        }
    }



    // localStorage.setItem('areaId', '410800');
    // localStorage.setItem('name', '123');
    // // linkWay:jzjkt
    // // handleType:own/other
    // localStorage.setItem('linkWay', 'jzjkt');
    // localStorage.setItem('handleType', 'own');
    // localStorage.setItem('phone', '17600989898');

    // localStorage.setItem('cardNo', '3621894638914631982');

    // localStorage.setItem('areaCode', '410800');

    // localStorage.setItem('otherName', '93930');

    // // localStorage.setItem('otherCardNo', '8327730213720730123');
    // localStorage.setItem('wxId', '41');
    // // localStorage.setItem('userId', '1381141');
    // localStorage.setItem('userId', '1114562');
    // localStorage.setItem('hosId', '1019')
    // localStorage.setItem('qrView', '1');
    // localStorage.setItem('unionId', 'o938BtNJJm2qIzbo7ouTNRne1zNk');
    // localStorage.setItem('openId', 'o3GXq0CVuWT64-Q4RBVfO59-KI04');
    // localStorage.setItem('token', 'eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiIxMTE0NTYyIiwidXNlcklkIjoiMTExNDU2MiIsIm5hbWUiOiIxMTE0NTYyIiwiZXhwIjoxNzQwMzc5NTM0fQ.g-EF2VHIedrvpvzP320WJ3Ym6WZqrCzusVqtxNj6i5nsfgdrkbGU-SbkXuPk_KKK0D4JKj8_OK5hGocAqMVxJHSFah45YjSQCDNbuaCKz3GXIlG3gVTPJCt_g3JT2AL0VGcs-w5Vd_yd4F3cBCfUOJ8io1n3xkgjNFNGO_xxW7E')
    let urlinfo = window.location.href;
    // let urlinfo = 'https://m.seemeeting.cn/dist/index.html?id=0&wxId=12&hosId=1024#/home'
    console.log(urlinfo)
    
     //  是否第一次进入
  // let isFirstDay = false;
  let todaytime = formatTime1(new Date())
  let lasttime = localStorage.getItem('lasttime')
  var everypage = JSON.parse(localStorage.getItem('everypage'))
  // var everypage = {}
  console.log(lasttime,everypage)
  if((lasttime || everypage) == '' || (lasttime || everypage) == undefined || (lasttime ||everypage) == null || todaytime != lasttime){
      console.log('第一次进入，没有日期存放')
      console.log(todaytime)
      localStorage.setItem('lasttime', todaytime)
      var everypageobj = new Object();
      everypageobj.yewuxuanze = 0
      everypageobj.zhaopianshangchuan = 0
      everypageobj.indexpage = 1
      everypageobj.writeinformation = 0
      everypageobj.printinformation = 0
      everypageobj.payinformation = 0
     console.log(everypageobj,'app')
     localStorage.setItem("everypage", JSON.stringify(everypageobj));
  }else if(todaytime == lasttime){

      console.log('已经进来过了，当天')
  }
 

    urlinfo = urlinfo.substring(0, urlinfo.indexOf('#'));

    // if (util.isNullString(userId) || util.isNullString(token)) {
    if (urlinfo.indexOf("?") != -1) {
        let json = parseQueryString(urlinfo);
        console.log(json)
        let wxId = json["wxId"];
        let userId = json["userId"];
        let newsid = json["id"];
        let token = json['token'];
        let hosId = json['hosId'];
        let channel = json['channel'];
        let promoter = json['promoter'];
        let cmsOrderId = json['cmsOrderId'];
        let requestId = json['requestId'];
        let areaId = json['areaId'];
        let name = json['name'];
        let linkWay = json['linkWay'];
        let handleType = json['handleType'];
        let phone = json['phone'];
        let cardNo = json['cardNo'];
        let areaCode = json['areaCode'];
        let otherName = json['otherName'];
        let otherCardNo = json['otherCardNo'];
        let ignorePeriod = json['ignorePeriod'];
        let unionId = json["unionId"];
        let openId = json["openId"];
        console.log(areaId)
        // let qrView = json['qrView']
        console.log(cmsOrderId)
        if (wxId != null) {
            localStorage.setItem('wxId', wxId);
        }
        if (ignorePeriod != null) {
            localStorage.setItem('ignorePeriod', ignorePeriod);
        } else {
            localStorage.removeItem('ignorePeriod')
        }
        if (hosId != null) {
            localStorage.setItem('hosId', hosId);
            console.log(hosId)
        }
        if(areaId != null){
            localStorage.setItem('areaId', areaId);
            localStorage.removeItem('areaCode')
            console.log(areaId)    
        }else{
            if(areaCode != null){
                localStorage.setItem('areaCode', areaCode);
                localStorage.setItem('areaId', areaCode);
            }else{
                localStorage.removeItem('areaCode')
                localStorage.removeItem('areaId')
            }
        }
        if (name != null) {
            localStorage.setItem('name', name);
            console.log(name)
        } else {
            localStorage.removeItem('name')
        }
        if (linkWay != null) {
            localStorage.setItem('linkWay', linkWay);
            console.log(linkWay)
        } else {
            localStorage.removeItem('linkWay')
        }
        if (handleType != null) {
            localStorage.setItem('handleType', handleType);
            console.log(handleType)
        } else {
            localStorage.removeItem('handleType')
        }
        if (phone != null) {
            localStorage.setItem('phone', phone);
            console.log(phone)
        } else {
            localStorage.removeItem('phone')
        }
        if (cardNo != null) {
            localStorage.setItem('cardNo', cardNo);
            console.log(cardNo)
        } else {
            localStorage.removeItem('cardNo')
        }
        if (otherName != null) {
            localStorage.setItem('otherName', otherName);
            console.log(otherName)
        } else {
            localStorage.removeItem('otherName')
        }
        if (otherCardNo != null) {
            localStorage.setItem('otherCardNo', otherCardNo);
            console.log(otherCardNo)
        } else {
            localStorage.removeItem('otherCardNo')
        }
       
        urlinfo = urlinfo.replace('&', "%26");
        if (userId != null) {
            localStorage.setItem('userId', userId);
        }
        if (channel != null) {
            localStorage.setItem('channel', channel);
        }
        if (promoter != null) {
            localStorage.setItem('promoter', promoter);
        }
        if (token != null) {
            localStorage.setItem('token', token);
        }
        if (unionId != null) {
            localStorage.setItem('unionId', unionId);
        }
        if (openId != null) {
            localStorage.setItem('openId', openId);
        }
        // if (qrView != null) {
        //     localStorage.setItem('qrView', qrView);
        // }
        token = localStorage.getItem('token');
        userId = localStorage.getItem('userId');
        console.log(token, '这是token')
        console.log(userId, '这是userId')


        if ((userId == null && token == null) || (userId != null && token == null) || (userId == null && token != null)) {
            let params = {
                wxId: wxId,
                type: '1',
                returnUrl: urlinfo
            }
            userLogin(params);
            return;
        } else {
            let tokenparams = {
                wxId: wxId,
                userId: userId,
                token: token
            }
            server.validateToken(tokenparams).then(data => {
                console.log(data)
                if (data.result == 2000 || data.result == 200) {
                    let params = {
                        wxId: wxId,
                        type: '1',
                        returnUrl: urlinfo
                    }
                    userLogin(params);
                    return;
                }
            })
            // let currentTime = new Date().getTime();
            // let oldTime = Number(localStorage.getItem("localTime"));
            // if (oldTime > 0) {
            //     if ((currentTime - oldTime) > (1000 * 60 * 60 * 24 * 1)) {
            //         localStorage.removeItem("userId");
            //         localStorage.removeItem("token");
            //         // localStorage.removeItem('defaultHospital');
            //         // localStorage.clear();
            //         let params = {
            //             wxId: wxId,
            //             type: '1',
            //             returnUrl: urlinfo
            //         }
            //         userLogin(params);
            //         return;
            //     }
            // }

        }
        hosId = localStorage.getItem('hosId')
        console.log("local hosId:" + hosId)
        if (hosId == 'null' || hosId == null) {
            hosId = '-1'
        }
        // let hosIdRouter = router.params.hosId;
        // console.log(to)
        if (to.params.hosId != null) {
            hosId = to.params.hosId
            console.log("params hosId:" + hosId)
        }
        // console.log('useriD没有获取到')

        switch (newsid) {
            case '0':
                if (to.name == 'apply') {
                    next()
                } else {
                    /**
                     * id=0时跳转也为home页问题解决，暂时保留
                     */
                    // if (to.name == 'home'&&from.name == null) {
                    // 	router.push('/apply/' + hosId + '/' + '-1')
                    // } else {
                    // 	next();
                    // }
                    if (to.name == 'home' && from.name == 'apply') {
                        router.push('/apply/' + hosId + '/' + '-1')
                    } else {
                        next();
                    }

                }
                break
            case '1':
                if (to.name == 'upload') {
                    next()
                } else {
                    router.replace('/upload')
                }

                break

            case '2':
                if (to.name == 'info') {
                    next()
                } else {
                    router.replace('/info')
                }
                break
            case '3':
                if (to.name == 'purpose') {
                    next()
                } else {
                    router.replace('/purpose')
                }
                // router.replace('/purpose')
                break
            case '4':
                if (to.name == 'applylist') {
                    next()
                } else {
                    router.replace('/apply-list')
                }
                // router.replace('/apply-list')
                break
            case '5':
                if (to.name == 'pay') {
                    next()
                } else {
                    router.replace('/pay/' + requestId + '/' + '0')
                }
                break
            case '6':
                if (to.name == 'makeup') {
                    next()
                } else {
                    if (from.name == null) {
                        router.replace('/makeup/' + requestId)
                    } else {
                        next()
                    }

                }

                break
            case '7':
                if (to.name == 'home') {
                    next()
                }
                // else{
                // 	router.replace('/home');
                // }

                break
            case '8':
                if (to.name == 'hotline') {
                    next()
                } else {
                    router.replace('/hotline');
                }

                break

            case '10':
                if (to.name == 'advertisingapply') {
                    next()
                } else {
                    router.replace('/advertisingapply');
                }
                break
            case '11':
                if (to.name == 'adverapplyafter') {
                    next()
                } else {
                    router.replace('/adverapplyafter/' + cmsOrderId);
                }
                break
            case '12':
                if (to.name == 'makeinvoice') {
                    next()
                } else {
                    router.replace('/makeinvoice');
                }
                break
            // case '13':
            //     if (to.name == 'hos-list') {
            //         next()
            //     } else {
            //         router.replace('/hos-list');
            //     }
            //     break
            default:
            // next()
        }
        next()
    } else {
        next()
    }

})

function parseQueryString(url) {

    var str = url.split("?")[1];
    var iterms = str.split("&");
    var arr, Json = {};

    for (var i = 0; i < iterms.length; i++) {
        arr = iterms[i].split("=");
        Json[arr[0]] = arr[1];
    }
    return Json;
}

function formatTime1(date) {
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
    return [year, month, day].map(formatNumber).join('/')
}
function formatNumber(n) {
    n = n.toString()
    return n[1] ? n : '0' + n
}

/**
 * 用户登录接口
 */
function userLogin(params) {
    server.login(params).then(data => {
        if (data.result == 1) {
            console.log(data, '这里是登录的data数据')
            let redirectUrl = data.redirectUrl;
            console.log("login:" + redirectUrl)
            window.location.href = redirectUrl
        }
    })
}


export default router